import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Fuel, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

const OPTS = [["over", "فوق الحد فقط", "المندوب يتحمّل الزيادة عن حد/شريحة البنزين"], ["full", "كامل المبلغ", "يُخصم كل بنزين الشهر من راتب المندوب في كل الحالات"]];

export const FuelChargeMode = ({ canEdit = true, onChanged, testid = "fuel-charge-mode" }) => {
  const [mode, setMode] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.fuelSettings().then((s) => setMode(s.charge_mode || "over")).catch(() => setMode("over")); }, []);
  const pick = async (m) => {
    if (m === mode || !canEdit) return;
    setBusy(m);
    try { await api.saveFuelSettings({ charge_mode: m }); setMode(m); toast.success(m === "full" ? "المندوب يتحمّل كامل مبلغ البنزين" : "المندوب يتحمّل ما فوق الحد فقط"); onChanged?.(m); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(""); }
  };
  return (
    <div className="rounded-xl border border-orange-200 bg-orange-50/50 p-3 space-y-2" data-testid={testid}>
      <p className="flex items-center gap-1.5 text-sm font-bold text-orange-800"><Fuel className="h-4 w-4" /> طريقة تحميل البنزين على المندوب <span className="text-[10px] font-normal text-orange-600">(إعداد عام للشركة)</span></p>
      <div className="grid grid-cols-2 gap-2">
        {OPTS.map(([k, l, d]) => (
          <button key={k} type="button" disabled={!canEdit || !!busy || mode === null} onClick={() => pick(k)} data-testid={`${testid}-${k}`}
            className={`rounded-lg border px-3 py-2 text-right transition-colors ${mode === k ? "border-orange-500 bg-white ring-2 ring-orange-200" : "border-slate-200 bg-white/60 hover:bg-white"}`}>
            <span className="flex items-center gap-1.5 text-sm font-semibold text-slate-800">
              {busy === k ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <span className={`h-3 w-3 rounded-full border-2 ${mode === k ? "border-orange-500 bg-orange-500" : "border-slate-300"}`} />}{l}
            </span>
            <span className="mt-0.5 block text-[11px] text-slate-500">{d}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const BulkFuelChargeMode = ({ selected, onDone }) => {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  if (!selected?.size) return null;
  const apply = async () => {
    if (!v) return toast.error("اختر طريقة تحميل البنزين");
    setBusy(true);
    try {
      const r = await api.bulkFuelChargeMode([...selected], v === "default" ? "" : v);
      toast.success(`تم تحديث تحميل البنزين لـ ${r.updated} مندوب`); setV(""); onDone && onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التحديث"); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1" data-testid="bulk-fuel-charge-mode">
      <select value={v} onChange={(e) => setV(e.target.value)} data-testid="bulk-fuel-charge-mode-select" className="h-8 rounded-md border border-slate-200 bg-white px-2 text-xs">
        <option value="">تحميل البنزين…</option>
        <option value="default">حسب إعداد الشركة</option>
        <option value="over">فوق الحد فقط</option>
        <option value="full">كامل المبلغ</option>
      </select>
      <Button type="button" size="sm" className="h-8 bg-orange-600 hover:bg-orange-700" disabled={busy} onClick={apply} data-testid="bulk-fuel-charge-mode-apply">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "تطبيق"}
      </Button>
    </div>
  );
};
